module.exports = __webpack_public_path__ + "media/images/common/header/sub_info-95b6f30a00cf489ee9728d6c7fe0ed5e.svg";